module.exports = __webpack_public_path__ + "img/bestexpress_charge_logo.b532e751.png";